import Siema from 'siema'
import LazyLoad from 'vanilla-lazyload'

const projectHandleMouseMove = (e, yOffset, xOffset, target) => {
  target.style.top = e.pageY + yOffset + 'px'
  target.style.left = e.pageX + xOffset + 'px'
}

const projectSetEvents = (project) => {
  let yOffset = 0
  let xOffset = 0
  if (project.getAttribute('data-thumburl')) {
    const preview = document.createElement('p')
    preview.id = 'preview'
    preview.style.height = project.getAttribute('data-thumbheight') + 'px'
    preview.style.width = project.getAttribute('data-thumbwidth') + 'px'
    preview.innerHTML = "<img src='" + project.getAttribute('data-thumburl') + "'  height='" + project.getAttribute('data-thumbheight') + "' width='" + project.getAttribute('data-thumbwidth') + "'/>"

    project.addEventListener('mouseenter', (e) => {
      const w = window
      const d = document
      const de = d.documentElement
      const g = d.getElementsByTagName('body')[0]
      // const wWidth = w.innerWidth || de.clientWidth || g.clientWidth
      const wHeight = w.innerHeight || de.clientHeight || g.clientHeight

      if (e.clientY >= wHeight / 2) {
        yOffset = -project.getAttribute('data-thumbheight') * 0.8
        xOffset = 0
      } else {
        yOffset = -project.getAttribute('data-thumbheight') * 0.25
        xOffset = 0
      }
      document.body.appendChild(preview)
      project.addEventListener('mousemove', (e) => {
        projectHandleMouseMove(e, yOffset, xOffset, preview)
      }, false)
    })
    project.addEventListener('mouseleave', (e) => {
      if (preview) {
        preview.remove()
      }
      project.removeEventListener('mousemove', projectHandleMouseMove)
    }, false)
  }
}

let projects = null
if ((projects = document.querySelectorAll('li.projet'))) {
  let i = -1

  while (++i < projects.length) {
    projectSetEvents(projects[i])
  }
}

if (document.querySelector('.gallery-container')) {
  const handleEvents = () => {
    const prevBtn = document.querySelector('.nav-left')
    const nextBtn = document.querySelector('.nav-right')

    prevBtn.addEventListener('click', () => {
      siema.prev()
    }, false)
    nextBtn.addEventListener('click', () => {
      siema.next()
    }, false)
    document.addEventListener('keyup', function (e) {
      console.log(e)
      e.preventDefault()
      if (e.which === 37) {
        siema.prev()
      } else if (e.which === 39) {
        siema.next()
      }
    }, false)
  }
  const siema = new Siema({
    selector: '.gallery-container',
    duration: 500,
    easing: 'ease-in-out',
    perPage: 1,
    startIndex: 0,
    draggable: true,
    multipleDrag: true,
    threshold: 20,
    loop: false,
    onInit: () => {
      handleEvents()
      const lazy = new LazyLoad({
        elements_selector: '.lazy'
      })
    },
    onChange: () => {}
  })
} else {
  const lazy = new LazyLoad({
    elements_selector: '.lazy'
  })
}

let links = document.links
let i = -1
while (++i < links.length) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank'
  }
}



// WEBPACK FOOTER //
// ./src/js/index.js